/* Club EarlyBird Javvy storefront: real Stamped numbers for every review count on the page.
   Same endpoint ceb-cro.js uses (initRating): https://stamped.io/api/widget, with window.StampedGlobalOptions.
   [data-cebjv-rv="count|avg"]            -> this product's Stamped totals (from #stamped-main-widget or [data-cebjv-stamped])
   [data-cebjv-rv="total|total-avg|total-five"] -> brand totals (Morning Cocktail listing, same as the live PDP)
   [data-cebjv-bar="5..1"], [data-cebjv-barn] -> star distribution
   Containers marked .statband / [data-cebjv-summary] stay hidden until real numbers arrive. */
(function () {
  'use strict';
  var BRAND = { id: '4626227200071', sku: 'earlybird-morning-cocktail-variety-pack' };
  var fmt = function (n) { return Number(n).toLocaleString('en-US'); };

  /* Public widget key from layout/cebjv.liquid (StampedFn.init). Used straight away so the numbers do not wait
     for the Stamped widget script, which the theme lazy-loads until the visitor interacts with the page. */
  var KEY = { apiKey: 'pubkey-S4K0QQ3T970n3N6pns4k57UF7hYL76', sId: '135809' };
  function options() {
    var o = window.StampedGlobalOptions;
    return o && o.apiKey && o.sId ? o : KEY;
  }

  /* up to 3 tries (blocked or slow network), then give up and tidy the page */
  async function statsRetry(o, id, sku) {
    var waits = [0, 2000, 5000], err;
    for (var i = 0; i < waits.length; i++) {
      if (waits[i]) await new Promise(function (r) { setTimeout(r, waits[i]); });
      try { return await stats(o, id, sku); } catch (e) { err = e; }
    }
    throw err;
  }

  /* No number could be loaded: hide the empty slots instead of showing "( )" or " Reviews". */
  function tidy() {
    document.querySelectorAll('[data-cebjv-rv]').forEach(function (el) {
      if (el.textContent.trim()) return;
      var pill = el.closest('.h-stats > span');
      if (pill) { pill.hidden = true; return; }
      var a = el.previousSibling, b = el.nextSibling;
      if (a && a.nodeType === 3 && /\(\s*$/.test(a.data) && b && b.nodeType === 3 && /^\s*\)/.test(b.data)) {
        a.data = a.data.replace(/\s*\(\s*$/, ''); b.data = b.data.replace(/^\s*\)/, '');
      }
      el.hidden = true;
    });
  }

  async function stats(o, id, sku) {
    var url = new URL('https://stamped.io/api/widget');
    var q = { productId: id, productSKU: sku || '', page: 1, take: 1, apiKey: o.apiKey, sId: o.sId };
    Object.keys(q).forEach(function (k) { url.searchParams.set(k, q[k]); });
    var r = await fetch(url);
    if (!r.ok) throw new Error('Stamped ' + r.status);
    var d = await r.json();
    var count = Number(d.count), rating = Number(d.rating);
    if (!count || !rating) throw new Error('No Stamped rating');
    var bars = {};
    var doc = new DOMParser().parseFromString(d.product || '', 'text/html');
    doc.querySelectorAll('.summary-rating').forEach(function (el) {
      var star = el.querySelector('.summary-rating-bar');
      if (star) bars[star.dataset.rating] = Number(el.dataset.count || 0);
    });
    return { count: count, rating: rating, bars: bars };
  }

  function fill(prefix, s) {
    var set = function (key, val) { document.querySelectorAll('[data-cebjv-rv="' + key + '"]').forEach(function (el) { el.textContent = val; }); };
    set(prefix + 'count', fmt(s.count));
    set(prefix + 'avg', s.rating.toFixed(1));
    if (prefix === 'total-') set('total', fmt(s.count));
    if (s.bars[5] !== undefined) set(prefix + 'five', fmt(s.bars[5]));
  }

  async function run() {
    var o = options();
    var w = document.querySelector('#stamped-main-widget') || document.querySelector('[data-cebjv-stamped]');
    var wantProduct = w && document.querySelector('[data-cebjv-rv="count"],[data-cebjv-rv="avg"],[data-cebjv-summary]');
    var wantBrand = document.querySelector('[data-cebjv-rv^="total"]');
    try {
      if (wantBrand) {
        var b = await statsRetry(o, BRAND.id, BRAND.sku);
        fill('total-', b);
        document.querySelectorAll('.statband').forEach(function (el) { el.classList.add('is-ready'); });
      }
    } catch (e) { /* leave hidden: never show invented numbers */ }
    try {
      if (wantProduct) {
        var s = await statsRetry(o, w.dataset.productId, w.dataset.productSku);
        fill('', s);
        var total = Object.keys(s.bars).reduce(function (a, k) { return a + s.bars[k]; }, 0) || s.count;
        document.querySelectorAll('[data-cebjv-bar]').forEach(function (el) {
          var n = s.bars[el.dataset.cebjvBar] || 0;
          el.style.width = (n / total * 100).toFixed(1) + '%';
        });
        document.querySelectorAll('[data-cebjv-barn]').forEach(function (el) { el.textContent = fmt(s.bars[el.dataset.cebjvBarn] || 0); });
        document.querySelectorAll('[data-cebjv-summary]').forEach(function (el) { el.classList.add('is-ready'); });
      }
    } catch (e) { /* leave hidden */ }
  }
  /* Clamp the full Stamped list; "Show all reviews" expands it. */
  function clamp() {
    document.querySelectorAll('[data-cebjv-rvwrap]').forEach(function (w) {
      var wid = w.querySelector('#stamped-main-widget');
      var btn = w.querySelector('[data-cebjv-rvmore]');
      if (!wid || !btn) return;
      var LIMIT = 1100;
      var check = function () {
        if (w.classList.contains('is-open')) return;
        var tall = wid.scrollHeight > LIMIT + 200;
        w.classList.toggle('is-clamped', tall);
        btn.hidden = !tall;
      };
      btn.addEventListener('click', function () {
        w.classList.add('is-open');
        w.classList.remove('is-clamped');
        btn.hidden = true;
      });
      if (window.MutationObserver) new MutationObserver(check).observe(wid, { childList: true, subtree: true });
      [0, 1500, 4000, 8000].forEach(function (t) { setTimeout(check, t); });
    });
  }
  /* Featured 5-star review card (Javvy puts one under the gallery). Real Stamped review, picked by length. */
  var esc = function (t) { var d = document.createElement('div'); d.textContent = t || ''; return d.innerHTML; };
  async function featured() {
    var slots = document.querySelectorAll('[data-cebjv-featured]');
    // Javvy layout: the card sits under the gallery thumbnails, not over the hero image
    slots.forEach(function (el) {
      var th = el.closest('.jg') && el.closest('.jg').querySelector('.jg-thumbs');
      if (th) { el.classList.remove('is-over'); th.after(el); }
    });
    var w = document.querySelector('#stamped-main-widget') || document.querySelector('[data-cebjv-stamped]');
    if (!slots.length || !w || !w.dataset.productId) return;
    var o = options();
    var url = new URL('https://stamped.io/api/widget/reviews');
    var q = { productId: w.dataset.productId, apiKey: o.apiKey, sId: o.sId, take: 50, page: 1, sortReviews: 'highest-rating', minRating: 5 };
    Object.keys(q).forEach(function (k) { url.searchParams.set(k, q[k]); });
    try {
      var d = await (await fetch(url)).json();
      var ok = (d.data || []).filter(function (r) {
        var n = (r.reviewMessage || '').length;
        return Number(r.reviewRating) === 5 && r.reviewTitle && n >= 60 && n <= 240;
      });
      ok.sort(function (a, b) { return (b.featured === 'true') - (a.featured === 'true'); });
      var r = ok[0];
      if (!r) return;
      var star = '<svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true"><path fill="#FFB400" d="M12 2l2.9 6.6 7.1.6-5.4 4.7 1.6 7L12 17.3 5.8 21l1.6-7L2 9.2l7.1-.6z"/></svg>';
      var html = '<div class="jrev-stars" aria-label="5 out of 5 stars">' + star + star + star + star + star + '</div>'
        + '<p class="jrev-t">' + esc(r.reviewTitle) + '</p>'
        + '<p class="jrev-b">&ldquo;' + esc(r.reviewMessage.trim()) + '&rdquo;</p>'
        + '<p class="jrev-a"><span class="jrev-av" aria-hidden="true">' + esc((r.author || '?').trim().charAt(0)) + '</span><b>' + esc(r.author) + '</b>'
        + (r.reviewVerifiedType && r.reviewVerifiedType !== '0' ? '<span class="jrev-v">Verified Buyer</span>' : '') + '</p>';
      slots.forEach(function (el) { el.innerHTML = html; el.hidden = false; });
    } catch (e) { /* no card */ }
  }

  var start = function () { clamp(); featured(); run().then(tidy, tidy); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
